const formatDate = (date: any, withTime: boolean = false) => {
  let dd = date.getDate();
  let mm = date.getMonth() + 1;
  const y = date.getFullYear();

  if (dd < 10) dd = `0${dd}`;
  if (mm < 10) mm = `0${mm}`;

  const resultDate = `${dd}.${mm}.${y}`;

  if (withTime) {
    const time = `${(`0${date.getHours()}`).slice(-2)}:${(`0${date.getMinutes()}`).slice(-2)}`;
    return `${resultDate} um ${time}Uhr`;
  }

  return resultDate;
};

export default formatDate;
